import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, AlertTriangle } from "lucide-react";
import { useAuth, roleHome } from "../context/AuthContext";
import { apiErr } from "../lib/api";
import { NeonLogo } from "../components/common";

const C = { cyan: "#00FFD1", magenta: "#FF2EA6" };

export default function Verify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [error, setError] = useState(null);
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const token = params.get("token");
    if (!token) { setError("Geen token gevonden."); return; }
    loginWithToken(token)
      .then((user) => navigate(roleHome(user.role), { replace: true }))
      .catch((err) => setError(apiErr(err.response?.data?.detail)));
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center font-outfit text-white relative overflow-hidden p-6 text-center" style={{ background: "#050507" }}>
      <div className="absolute inset-0 neon-grid opacity-50 pointer-events-none" />
      <div className="glow-orb" style={{ width: 360, height: 360, background: C.cyan, top: -80, left: -60 }} />
      <div className="glow-orb" style={{ width: 320, height: 320, background: C.magenta, bottom: -60, right: -40 }} />

      <div className="relative z-10 mb-10"><NeonLogo /></div>

      {!error ? (
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="relative z-10 flex flex-col items-center">
          <div className="w-14 h-14 rounded-full border-4 animate-spin mb-6" style={{ borderColor: "rgba(0,255,209,0.2)", borderTopColor: C.cyan }} />
          <p className="font-display text-xl font-bold text-slate-200">Bezig met inloggen...</p>
          <p className="mt-2 text-slate-500 font-mono text-sm">je avontuur wordt geladen…</p>
        </motion.div>
      ) : (
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="relative z-10 flex flex-col items-center">
          <div className="w-20 h-20 rounded-3xl flex items-center justify-center mb-6 box-glow-magenta" style={{ background: "rgba(255,46,166,0.12)" }}>
            <AlertTriangle className="w-10 h-10" strokeWidth={2.5} style={{ color: C.magenta }} />
          </div>
          <p className="font-display text-2xl font-extrabold">Oeps! 😕</p>
          <p className="mt-2 text-slate-400 font-medium max-w-sm">{error}</p>
          <Link to="/login" data-testid="verify-back-login"
            className="mt-7 inline-flex items-center gap-1 px-7 py-3 rounded-full font-bold text-black box-glow-cyan active:scale-95 hover:opacity-90 transition-all" style={{ background: C.cyan }}>
            Terug naar inloggen <ArrowRight className="w-4 h-4" />
          </Link>
        </motion.div>
      )}
    </div>
  );
}
